module.exports = __webpack_public_path__ + "34fe5598ef83487f46a3ee8dd564fcab.png";